export default "__VITE_ASSET__21500ecb__"